// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const base = '/fleet-tracing'

export const BaseFleetTracingAreaRoutes = {
  route: base,
  Vehicle: {
    route: '/vehicle',
  },
}

export const FleetTracingAreaRoutes = transformRoutes(
  BaseFleetTracingAreaRoutes,
)
